import React from 'react';
import { observer } from 'mobx-react-lite';
import getImgSrcWithPrefix from 'utils/getImgSrcWithPrefix';
import MobileSlider from 'generic/MobileSlider';
import { useStores } from 'hooks/useStores';
import { MobileGalleryStyles, Image } from './MobileGalleryStyles';

const MobileGallery = observer(() => {
  const {
    advertsStore: {
      currentAdvert: { photos },
    },
  } = useStores();

  if (!photos) return null;

  const photosWithSizePrefix = photos.map((src) => getImgSrcWithPrefix(src, 'lg'));

  return (
    <MobileGalleryStyles>
      <MobileSlider photos={photosWithSizePrefix} />
    </MobileGalleryStyles>
  );
});

export default MobileGallery;
